// fe/src/components/tools/event-logistics/index.js

import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import EventsPlanner from './EventsPlanner';
import SavedPlans from './SavedPlans';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const EventsPlannerIndex = () => {
  const { path, url } = useRouteMatch();

  return (
    <Router>
      <Switch>
      <Route path={path} exact>
          <EventsPlanner />
        </Route>
        <Route exact path={`${path}/saved`}>
          <SavedPlans />
        </Route>
       
      </Switch>
    </Router>
  );
};

export default EventsPlannerIndex;